import Typography from "@/src/views/components/Typography";
import styles from "./index.module.scss";
import { useEffect, useRef } from "react";
import PointLine2 from "@/src/views/components/Icon/icons/PointLine2";
import { OtherProduct, ShowcaseProduct, WordStyling } from "@/src/types/landingPage";
import ProductDetail from "../ProductDetail";

export default function LandingOverview({
  showcases,
  others,
  total_usecase,
  listWordStyling,
}: {
  showcases: ShowcaseProduct[];
  others: OtherProduct[];
  total_usecase: number;
  listWordStyling: WordStyling[];
}) {
  const titleRef = useRef(null);
  const circleRef = useRef(null);
  const otherRef = useRef(null);
  const otherLogoRef = useRef(null);

  useEffect(() => {
    const options = {
      root: null, // use the viewport as the root
      rootMargin: '0px',
    };

    const callback: IntersectionObserverCallback = (
      entries: IntersectionObserverEntry[],
      observer: IntersectionObserver,
    ) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (entry.target === otherLogoRef.current) {
            for (let index = 0; index < entry.target.children.length; index++) {
              const child = entry.target.children.item(index);
              child.classList.add(styles["visible"]);
            }
          } else {
            entry.target.classList.add(styles["visible"]);
          }
          
          observer.unobserve(entry.target)
        }
      });
    };
    const observer = new IntersectionObserver(callback, options);
  
    if (titleRef.current) {
      observer.observe(titleRef.current);
    }
    if (circleRef.current) {
      observer.observe(circleRef.current);
    }
    if (otherRef.current) {
      observer.observe(otherRef.current);
    }
    if (otherLogoRef.current) {
      observer.observe(otherLogoRef.current);
    }
    // Clean up
    return () => {
      observer.disconnect();
    };
  }, [
    titleRef,
    circleRef,
    otherRef,
    otherLogoRef,
  ]);

  return (
    <div
      className={styles["products-section"]}
    >
      <div className={styles["point-line"]}>
        <PointLine2 />
      </div>
      <div
        ref={titleRef}
        className={styles["title-wrapper"]}
      >
        <div className={styles["header"]}>
          <Typography variant="heading-6-bold" color="black">
            Lebih dari&nbsp;
          </Typography>
          <Typography variant="heading-6-bold" color="orange80">
            <>{total_usecase} use cases&nbsp;</>
          </Typography>
          <Typography variant="heading-6-bold" color="black">
            telah dikembangkan pada&nbsp;
          </Typography>
          <Typography variant="heading-6-bold" color="blue80">
            {`${showcases?.length + others?.length} produk BRI`}
          </Typography>
        </div>
        <Typography variant="heading-2-medium" color="dark40">
          sebagai solusi untuk meningkatkan kinerja bisnis BRI
        </Typography>
      </div>
      <div className={styles["product-list-wrapper"]}>
        {showcases?.map((produk) => (
          <ProductDetail
            key={produk.nama_produk}
            product={produk}
            listWordStyling={listWordStyling}
          />
        ))}
        <div className={styles.content_container}>
          <div
            ref={circleRef}
            className={styles.circle_line_wrapper}>
            <div className={styles.circle_wrapper}>
              <div className={styles.circle} />
            </div>
            <div className={styles.line_filler} />
          </div>
          <div
            ref={otherRef}
            className={styles.others_wrapper}
          >
            <Typography variant='subtitle-5-bold' color='dark40' >
              {`dan ${others?.length} produk lainnya`}
            </Typography>
            <div
              ref={otherLogoRef}
              className={styles.logo_wrapper}>
              {others?.map((other, index) => (
                <img
                  key={other.nama_produk}
                  className={styles.image_logo}
                  src={`${process.env.NEXT_PUBLIC_IMAGES}/${other.logo_produk}`}
                  style={{
                    transitionDelay: `${0.1+index*0.1}s`,
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
